import type { PaginationQueryRequest, PaginationQueryResponse } from '@vsolv/dev-kit/nest';
import { Model } from '../model';

export interface ListRequest extends PaginationQueryRequest {
  search?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export type ListResponse = PaginationQueryResponse<Model>;

export const ListDefaultResponse: ListResponse = {
  meta: { currentPage: 1, itemCount: 0, itemsPerPage: 10 },
  items: [],
};
